import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '../../sharedModule/shared.module';
import { DashboardAppsDeliveryMethodsSectionComponent } from './components/dashboard-apps-delivery-methods-section/dashboard-apps-delivery-methods-section.component';
import { DashboardAppsSectionComponent } from './components/dashboard-apps-section/dashboard-apps-section.component';
import { DashboardCarriersSectionComponent } from './components/dashboard-carriers-section/dashboard-carriers-section.component';
import { DashboardExceptionsSectionSubsectionComponent } from './components/dashboard-exceptions-section-subsection/dashboard-exceptions-section-subsection.component';
import { DashboardExceptionsSectionComponent } from './components/dashboard-exceptions-subsection/dashboard-exceptions-section.component';
import { DashboardGeneralSectionSubsectionComponent } from './components/dashboard-general-section/dashboard-general-section-subsection/dashboard-general-section-subsection.component';
import { DashboardGeneralSectionComponent } from './components/dashboard-general-section/dashboard-general-section.component';
import { DashboardSpecialFeaturesScansSectionComponent } from './components/dashboard-special-features-scans-section/dashboard-special-features-scans-section.component';
import { DashboardSpecialFeaturesSectionReportSubsectionComponent } from './components/dashboard-special-features-section-report-subsection/dashboard-special-features-section-report-subsection.component';
import { DashboardSpecialFeaturesSectionComponent } from './components/dashboard-special-features-section/dashboard-special-features-section.component';
import { DashboardSpecialFeaturesShelfReportSectionComponent } from './components/dashboard-special-features-shelf-report-section/dashboard-special-features-shelf-report-section.component';
import { DashboardSpecialFeaturesSpecialLabelSectionComponent } from './components/dashboard-special-features-special-label-section/dashboard-special-features-special-label-section.component';
import { DashboardSpecialFeaturesSubsectionsComponent } from './components/dashboard-special-features-subsections/dashboard-special-features-subsections.component';
import { DashboardToggleSubsectionComponent } from './components/dashboard-toggle-subsection/dashboard-toggle-subsection.component';
import { SectionHeaderComponent } from './components/section-header/section-header.component';
import { DashboardAppsEffects } from './store/effects/apps';
import { DashboardEffects } from './store/effects/dashboard';
import { RangeEffects } from './store/effects/range';
import { DashboardSpecialFeaturesEffects } from './store/effects/special-features';
import { dashboardReducer } from './store/reducers';
import { featureKey } from './store/states';

const MY_FORMATS = {
  parse: {},
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'YYYY',
  },
};

@NgModule({
  declarations: [
    SectionHeaderComponent,
    DashboardGeneralSectionComponent,
    DashboardSpecialFeaturesSectionComponent,
    DashboardAppsSectionComponent,
    DashboardCarriersSectionComponent,
    DashboardSpecialFeaturesSubsectionsComponent,
    DashboardSpecialFeaturesShelfReportSectionComponent,
    DashboardSpecialFeaturesSpecialLabelSectionComponent,
    DashboardToggleSubsectionComponent,
    DashboardSpecialFeaturesScansSectionComponent,
    DashboardAppsDeliveryMethodsSectionComponent,
    DashboardGeneralSectionSubsectionComponent,
    DashboardExceptionsSectionComponent,
    DashboardExceptionsSectionSubsectionComponent,
    DashboardSpecialFeaturesSectionReportSubsectionComponent,
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatIconModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    MatListModule,
    MatTooltipModule,
    StoreModule.forFeature(featureKey, dashboardReducer),
    EffectsModule.forFeature([DashboardEffects, DashboardAppsEffects, DashboardSpecialFeaturesEffects, RangeEffects]),
    SharedModule,
  ],
  providers: [],
  exports: [],
})
export class AnalyticsDashboardModule {}
